import { render, staticRenderFns } from "./OpportunityCategories.vue?vue&type=template&id=eb50285c&scoped=true&"
import script from "./OpportunityCategories.vue?vue&type=script&lang=js&"
export * from "./OpportunityCategories.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityCategories.vue?vue&type=style&index=0&id=eb50285c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb50285c",
  null
  
)

export default component.exports